<div class="card-header">
  <a role="button" (click)="toggleClick($event)">
    <h5 class="mb-0">
      <ng-content></ng-content>
      <i class="fa fa-angle-down rotate-icon"></i>
    </h5>
  </a>
</div>


// WEBPACK FOOTER //
// ./node_modules/ng-mdb-pro/pro/accordion/components/sb-item.head.html